import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import FileUpload from '../../../../component/FileUpload';
import classes from "./style.module.scss"


const ReportUpload = ({text, placeholder, files, setFiles,required, fileName, setFileName, onChange, acceptFiles, isFileUploading  }) => {

    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        getValues,
        trigger,
    } = formMethods;

    

    return (
        <div>
            <div className={`mt-5`}>
            <div className='mb-4'><span className={classes.titleHeader} style={{color : isFileUploading ? "#858485" : "#000000"  }}>Upload the TOD calculation update file</span> <span className='text-[#858485]'>(Supported format .xls, .XLSX)</span></div>
                <FileUpload
                    name="uploadResource"
                    className={`p-8 py-12 w-[100%]`}
                    control={formMethods.control}
                    setValue={formMethods.setValue}
                    clearErrors={formMethods.clearErrors}
                    setError={formMethods.setError}
                    error={errors.uploadResource}
                    required={required}
                    messages={{
                        required: "File is required",
                    }}
                    maxSize={20971520}
                    maxLable= "20MB"
                    label="Upload File"
                    acceptFiles=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    fileNames={fileName}
                    setFileName={setFileName}
                    uploadedFiles={files}
                    setUploadedFiles={setFiles}
                    isFileUploading={isFileUploading}
                    placeholder={placeholder}
                    alignment={'center'}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

export default ReportUpload